import script from "./GuessMetadataHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./GuessMetadataHeader.vue?vue&type=script&setup=true&lang=js"

import "./GuessMetadataHeader.vue?vue&type=style&index=0&id=2d94409e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d94409e"]])

export default __exports__